import { NgModule } from 'ng-metadata/core';
import {PrmCitationTrailsIndication} from './citationTrailsIndication.directive';
import {CitationTrailsBreadcrumbsService} from './citationTrailsBreadcrumbs.service';
import {PrmCitationTrailsItem} from './citationTrailsItem.directive';
import {FullViewPageService} from '../fullView/fullViewPage/fullViewPage.service';
import {FullViewDialogService} from '../fullView/fullViewDialog.service'
import {PrmCitationTrailsIndicationContainer} from './citationTrailsIndicationContainer.directive';
import {CitationTrailsFullviewLinkService} from './citationTrailsFullviewLink.service';
import 'angular-inview';
import {PrmCitationTrailsBreadcrumbs} from './citationTrailsBreadcrumbs.directive';
import {PrmCitationTrailsFullviewLink} from './citationTrailsFullviewLink.directive';

@NgModule({
    declarations: [
        PrmCitationTrailsBreadcrumbs,
        PrmCitationTrailsFullviewLink,
        PrmCitationTrailsIndication,
        PrmCitationTrailsIndicationContainer,
        PrmCitationTrailsItem
    ],
    providers: [
        CitationTrailsBreadcrumbsService,
        CitationTrailsFullviewLinkService,
        FullViewPageService,
        FullViewDialogService
    ],
    imports:[
        'angular-inview'
    ]
})
export class CitationTrailsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrails.module.ts